import { Link } from 'react-router-dom';

import { dateFormat, timeFormat } from 'common/helpers/dateHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const ReservationRow = (props) => {
  const { reservation, settings } = props;
  const item = {
    price: reservation.price
  };

  if (reservation.virtualCart) {
    item.price = reservation.virtualCart.items[0].price;
    item.comparePrice = reservation.virtualCart.items[0].comparePrice;
  }
  return (
    <div className="c7-account__reservation">
      <div>{dateFormat(reservation.reservationDate, settings)}</div>
      <div>
        <strong>Res No.</strong>
        <br />
        {reservation.reservationNumber}
      </div>
      <div>
        <strong>Type</strong>
        <br />
        {reservation.reservationType && reservation.reservationType.title}
        <br />
        {reservation.reservationTypeOption &&
          reservation.reservationTypeOption.title}
        <br />
        {currencyFormat(item.price, settings)}/person
      </div>
      <div>
        <strong>Details</strong>
        <br />
        {dateFormat(reservation.reservationDate, settings)} at{' '}
        {timeFormat(reservation.reservationDate, settings)}
        <br />
        Guests: {reservation.guestCount}
        <Status reservation={reservation} />
      </div>
      <div>
        <strong>
          {currencyFormat(item.price * reservation.guestCount, settings)}
        </strong>
      </div>
      <div>
        <Link
          to={`/profile/reservation/${reservation.id}`}
          className="c7-button-alt-small"
        >
          {' '}
          View details
        </Link>
      </div>
    </div>
  );
};

const Status = (props) => {
  const { reservation } = props;
  if (reservation.status === 'Cancelled') {
    return (
      <>
        <br />
        Status: {reservation.status}
      </>
    );
  }
  return null;
};

export default ReservationRow;
